export default {
	data() {
		return {
			showDetailStatusDialog: false,
			dialogTitle: '',
			openType: '',
			info: {},
			defaultTime: [], //数据展示-默认时间
		}
	},
	computed: {
		tenantType() {
			return this.$store.getters.userInfo.tenantType || '0'
		},

		pressureUnitName() {
			return this.$store.getters.pressureUnitName
		},
	},
	methods: {
		showDetailStatus(row) {
			this.defaultTime = []
			this.info = {
				name: '浓度',
				attributeKey: 'Density',
				unitName: '%LEL',
				deviceId: row.deviceId,
				createTime: row.createTime,
			}
			this.openType = 'alarm'
			this.dialogTitle = '浓度变化'
			// 告警已恢复则默认展示告警时间-告警恢复时间数据
			if (row.alarmStatus == 1) {
				this.defaultTime = [new Date(row.createTime), new Date(row.clearTime)]
			}
			this.$nextTick(() => {
				this.$refs.echartTable?.resetTime()
			})
			this.showDetailStatusDialog = true
		},
		showPressure(row) {
			this.info = {
				attributeKey: 'pressure',
				deviceId: row.deviceId,
				name: '压力',
				unitName: this.pressureUnitName,
				timeSeriesDesc: {
					drawType: ['list', 'lineChart'],
				},
				createTime: row.createTime,
			}
			this.openType = 'pressure'
			this.dialogTitle = '压力变化'
			this.$nextTick(() => {
				this.$refs.echartTable?.resetTime()
			})
			this.showDetailStatusDialog = true
		},
	},
}
